import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { Resources, useResource } from "Translations/Resources";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { useNavigate } from "Navigation/useNavigate";
import { useSearchParams } from "Navigation/useSearchParams";
import { appUrl } from "Utils/UrlUtils";
import { PaypointFormInitializer } from "Components/Paypoints/PaypointFormInitializer";
import { useGoBack } from "Navigation/useGoBack";
import type { ProductCode } from "Infrastructure/Api/Api";
import { isTerminalProductCode } from "Components/Shared/Merchant/Products/AppProducts/constants";

export const NewPaypointPage = () => {
  const { t } = useResource();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const merchantPublicID = searchParams.get("merchantPublicID") || undefined;
  const nfcCardNo = searchParams.get("nfcCardNo") || undefined;
  const productID = searchParams.get("productID")
    ? Number(searchParams.get("productID"))
    : null;
  const productCode = searchParams.get("productCode") as ProductCode | null;
  const isTerminalProduct = isTerminalProductCode(productCode);

  const { navigateBack } = useGoBack({
    mode: "historyStack",
    fallbackUrl: appUrl("paypoints"),
  });

  const navigateToMerchantPaypoints = () => {
    navigate(
      `${appUrl("merchant-detail")}/${merchantPublicID}?activeTab=paypoints`,
      { replace: true, resetHistory: true },
    );
  };

  return (
    <AuthenticatedLayout
      title={t(Resources.Paypoint.NewPaypoint)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: appUrl("paypoints"),
      }}
    >
      <StyledPageWrapper>
        <PrimaryPaper>
          <PaypointFormInitializer
            productID={productID}
            productCode={productCode}
            merchantPublicID={merchantPublicID}
            nfcCardNo={nfcCardNo}
            isTerminalProduct={isTerminalProduct}
            onSuccess={nfcCardNo ? navigateToMerchantPaypoints : navigateBack}
          />
        </PrimaryPaper>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};
